import { api } from "core";

const getTeachersFromSchoolReport = (school, projectSchool) =>
  api.instance
    .get(`${school}/activitiesReport/schools/${projectSchool}`)
    .then(({ data }) => data);

export default getTeachersFromSchoolReport;
